import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class movimientoService {
    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}logistica/movimiento/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excel(filter) {
        const response = await axios
            .get(`${ERP}logistica/movimiento/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}logistica/movimiento/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excelDetallado(filter) {
        const response = await axios
            .get(`${ERP}logistica/movimiento/excelDetallado?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdfDetallado(filter) {
        const response = await axios
            .get(`${ERP}logistica/movimiento/pdfDetallado?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async pdfA4(filter) {
        const response = await axios
            .get(`${ERP}logistica/movimiento/pdf-a4?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}logistica/movimiento/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    }

    async registrar(data) {
        const response = await axios
            .post(`${ERP}logistica/movimiento`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }

    async modificar(data) {
        const response = await axios
            .put(`${ERP}logistica/movimiento`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }


    async actualizarEstado(data) {
        const response = await axios
            .put(`${ERP}logistica/movimiento/actualizar-estado`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    }

    async registrarCargaMasiva(data) {
        const response = await axios
            .put(`${ERP}logistica/movimiento/registrar-carga-masiva`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async formatoCargaMasiva() {
        const response = await axios
            .get(`${ERP}logistica/movimiento/formato-carga-masiva`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async subirCargaMasiva(file) {
        const formData = new FormData();
        formData.append('file', file);
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };

        const response = await axios
            .post(`${ERP}logistica/movimiento/subir-carga-masiva`, formData, config)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async serieValidarExistencia(filter) {
        const response = await axios
            .get(`${ERP}logistica/movimiento/serieValidarExistencia?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async listarSeriesDisponibles(filter) {
        const response = await axios
            .get(`${ERP}logistica/movimiento/listarSeriesDisponibles?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

     async listarSeriesDisponiblesComprobante(filter) {
        const response = await axios
            .get(`${ERP}logistica/movimiento/listarSeriesDisponiblesComprobante?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

     async listarSeriesDisponiblesBySerie(filter) {
        const response = await axios
            .get(`${ERP}logistica/movimiento/listarSeriesDisponiblesBySerie?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

     async listarSeriesDisponiblesBySerieComprobante(filter) {
        const response = await axios
            .get(`${ERP}logistica/movimiento/listarSeriesDisponiblesBySerieComprobante?${global.formatParameter(filter)}`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

}

export default new movimientoService();